export default {
  // Start from the left side
  left: [
    {
      slot: 1,
      step: 1,
      side: 1
    },
    {
      slot: 2,
      step: 2,
      side: 1
    },
    {
      slot: 3,
      step: 5,
      side: 1
    },
    {
      slot: 6,
      step: 6,
      side: 2
    },
    {
      slot: 5,
      step: 4,
      side: 2
    },
    {
      slot: 4,
      step: 3,
      side: 2
    }
  ],
  // Start from the right side
  right: [
    {
      slot: 1,
      step: 3,
      side: 1
    },
    {
      slot: 2,
      step: 4,
      side: 1
    },
    {
      slot: 3,
      step: 6,
      side: 1
    },
    {
      slot: 6,
      step: 5,
      side: 2
    },
    {
      slot: 5,
      step: 2,
      side: 2
    },
    {
      slot: 4,
      step: 1,
      side: 2
    }
  ]
}
